<script setup lang="ts">
onBeforeMount(async () => {
  try {
    const { user } = useOidcAuth();
    const { data: userConfig } = await useLazyFetchAPI('/api/user/config', {
      immediate: !!user.value,
    });

    watch(userConfig, () => {
      if (userConfig.value) {
        useUserConfig().value = userConfig.value;
      }
    });
    watch(useUserConfig(), () => {
      useColorMode().preference =
        useUserConfig()?.value?.theme_preference ?? 'system';
    });

    Sentry.setUser({
      id: user.value?.userInfo?.sub,
      email: user.value?.userInfo?.email,
      username: user.value?.userInfo?.nickname ?? user.value?.userInfo?.name,
    });

    for (const key of ['sub', 'email', 'org_id', 'customerId', 'namespaceId']) {
      const value = user.value?.userInfo?.[key] as string | undefined;
      if (value) {
        Sentry.setTag(key, value?.toString());
      }
    }
  } catch (error) {
    console.error('Try `Sentry.setUser()`', error);
  }
});
</script>

<template>
  <div class="w-screen overflow-x-hidden overflow-y-hidden">
    <Navigation>
      <slot />
    </Navigation>
  </div>
</template>
